import React from "react";
import {
  getMunicipalitiesForState,
  getMunicipality,
  getStateByCode,
  getStates,
} from "../../utils/mexicoLocations";
import { selectCls } from "../../constants/formClasses";
import PortalSelect from "../PortalSelect";

/**
 * value: { stateCode: string, municipalityCode: string }
 * onChange: (next) => void
 * stateCodesFilter / municipalityCodesFilter: limitan opciones (p. ej. solo ubicaciones con psicólogos).
 */
export default function MexicoLocationSelects({
  value,
  onChange,
  disabled,
  stateCodesFilter = null,
  municipalityCodesFilter = null,
}) {
  const { stateCode = "", municipalityCode = "" } = value || {};
  const allStates = getStates();
  const states =
    stateCodesFilter === null
      ? allStates
      : allStates.filter((s) => stateCodesFilter.includes(s.code));
  const allMunicipalities = getMunicipalitiesForState(stateCode);
  const municipalities =
    municipalityCodesFilter === null
      ? allMunicipalities
      : allMunicipalities.filter((m) => municipalityCodesFilter.includes(m.code));
  const state = getStateByCode(stateCode);
  const muni = getMunicipality(stateCode, municipalityCode);
  const isCdmx = stateCode === "09";

  function setState(nextCode) {
    onChange({ stateCode: nextCode, municipalityCode: "" });
  }

  function setMunicipality(nextMuniCode) {
    onChange({ stateCode, municipalityCode: nextMuniCode });
  }

  return (
    <div className="space-y-4">
      <div>
        <label className="portal-label block mb-1.5">Estado</label>
        <PortalSelect
          className={selectCls}
          value={stateCode}
          onChange={(e) => setState(e.target.value)}
          disabled={disabled}
          required
        >
          <option value="">Selecciona estado</option>
          {states.map((s) => (
            <option key={s.code} value={s.code}>
              {s.name}
            </option>
          ))}
        </PortalSelect>
      </div>
      <div>
        <label className="portal-label block mb-1.5">
          {isCdmx ? "Alcaldía" : "Municipio"}
        </label>
        <PortalSelect
          className={selectCls}
          value={municipalityCode}
          onChange={(e) => setMunicipality(e.target.value)}
          disabled={disabled || !stateCode}
          required
        >
          <option value="">
            {stateCode ? `Selecciona ${isCdmx ? "alcaldía" : "municipio"}` : "Primero elige estado"}
          </option>
          {municipalities.map((m) => (
            <option key={m.code} value={m.code}>
              {m.name}
            </option>
          ))}
        </PortalSelect>
        {stateCode &&
          municipalityCodesFilter !== null &&
          municipalities.length === 0 && (
            <p className="mt-1.5 portal-meta">
              No hay consultas presenciales registradas en este estado por el momento.
            </p>
          )}
      </div>
      {state && muni && (
        <p className="portal-meta">
          Ciudad / ámbito urbano:{" "}
          <span className="font-semibold text-brand-navy">{muni.name}</span>
          {" · "}
          {state.name}
        </p>
      )}
    </div>
  );
}

export function locationToPayload(stateCode, municipalityCode) {
  if (!stateCode || !municipalityCode) return null;
  const st = getStateByCode(stateCode);
  const mu = getMunicipality(stateCode, municipalityCode);
  if (!st || !mu) return null;
  return {
    country: "MX",
    stateCode: st.code,
    stateName: st.name,
    municipalityCode: mu.code,
    municipalityName: mu.name,
    cityName: mu.name,
  };
}
